















































































































import { Mixins, Component, Provide, Ref } from "vue-property-decorator"
import PageHeader from "@/components/page-header/index.vue"
import PageMixin from "@/mixins/page"
import { PRODUCT_STATUS, getColumns } from "./constant"
import { pick } from "lodash"
import manageService from "@/services/manage.service"
import { mapGetters } from "vuex"
import { FormModel } from "ant-design-vue"
import { omit } from "lodash"
import dayjs from "dayjs"
@Component({
    name: "ProductList",
    components: {
        PageHeader
    },
    computed: {
        ...mapGetters(["currentUser"]),
        ...mapGetters("common", ["product_type", "product_sub_type", "corporation", "top_dept"])
    }
})
export default class ProductList extends Mixins(PageMixin) {
    @Provide()
    get useWrapperContext() {
        return this
    }
    @Ref("onShelf")
    refOnShelfForm: FormModel
    @Ref("offShelf")
    refOffShelfForm: FormModel

    readonly product_type: any
    readonly product_sub_type: any
    readonly corporation: any
    readonly top_dept: any
    readonly currentUser: any
    loading = false
    exportLoading = false
    tableData: any[] = []
    software_list: any[] = []
    sorts: any[] = []
    filters: any[] = []
    selectedRowKeys: number[] = []
    selectedRows: any[] = []

    productOption: any = []

    onShelf = {
        visible: false,
        record: {} as any,
        form: {
            on_shelf_time: ""
        }
    }
    offShelf = {
        visible: false,
        record: {} as any,
        form: {
            off_shelf_time: "",
            off_shelf_reason: ""
        }
    }
    searchParams = {
        keyword: "" as string,
        pagination: { current: 1, pageSize: 10 },
        sorts: [] as any[],
        filters: [] as any[]
    }
    pagination = {
        current: 1,
        pageSize: 10,
        showQuickJumper: true,
        showSizeChanger: true,
        showLessItems: true,
        size: "normal" as const,
        total: 0,
        pageSizeOptions: ["10", "20", "30", "40", "100"],
        showTotal: (total: number) => `共${total}项`
    }
    get vPaginationBinds() {
        const exclude = ["showTotal"]
        return omit(this.pagination, exclude)
    }

    isActive = true
    activated() {
        this.isActive = true
        this.$nextTick(() => {
            this.getList()
        })
    }

    deactivated() {
        this.isActive = false
    }

    // 修复分页事件处理
    handlePageChange(page: number, pageSize: number) {
        this.pagination.current = page
        this.pagination.pageSize = pageSize
        this.getList()
    }

    handleShowSizeChange(current: number, size: number) {
        this.pagination.pageSize = size
        this.pagination.current = 1
        this.getList()
    }
    get productType() {
        return this.product_type
    }

    // 二级分类(平台列表)
    get productSubType() {
        return this.product_sub_type
    }

    get corporationOption() {
        return this.corporation
    }

    get softwareList() {
        return this.software_list.map((item: any) => {
            return {
                label: item.software_name,
                value: item.software_id
            }
        })
    }

    get columns() {
        return getColumns(this)
    }

    get tableActions() {
        return (record: any) => {
            const actions = {
                edit: {
                    title: "编辑",
                    event: "edit"
                },
                recovery: {
                    title: "恢复",
                    event: "recovery",
                    need_confirm: true,
                    confirm_content: (h: any, record: any) => {
                        return h("span", null, `确定恢复${record.software_name || ""}吗？`)
                    }
                },
                onShelf: {
                    title: "上架",
                    event: "onShelf",
                    style: {
                        color: "#00A854"
                    }
                },
                offShelf: {
                    title: "下架",
                    event: "offShelf",
                    style: {
                        color: "red"
                    }
                }
            }

            let actionKeys: (keyof typeof actions)[] = []
            if (record.status === PRODUCT_STATUS.待上架) {
                actionKeys = ["edit", "onShelf", "offShelf"]
            } else if (record.status === PRODUCT_STATUS.正常) {
                actionKeys = ["edit", "offShelf"]
            } else if (record.status === PRODUCT_STATUS.下架) {
                actionKeys = ["edit", "recovery"]
            }
            const filteredActions = pick(actions, actionKeys)
            return Object.values(filteredActions)
        }
    }

    get topDept() {
        return this.top_dept
    }

    created() {
        this.getUserSoftware()
    }

    // 将输入的内容与显示的内容进行匹配
    filterOption(
        value: any,
        option: { componentOptions: { children: { text: string | any[] }[] } }
    ) {
        return option.componentOptions.children[0].text.indexOf(value) >= 0
    }

    async getUserSoftware() {
        try {
            const res = await manageService.getUserSoftware({
                uid: this.currentUser.uid
            })
            const { list = [] } = res || {}
            this.software_list = list || []
            this.getList()
        } catch (error) {
            this.$message.error(`${error}, 获取产品失败！`)
        }
    }

    getPopupContainer() {
        return (triggerNode: any) => triggerNode.parentNode
    }

    onView(records: any[]) {
        const record = records[0]
        this.$router.push({
            path: "/manage/product-detail",
            query: {
                software_id: String(record.software_id),
                product_id: String(record.product_id)
            }
        })
    }

    onEdit(records: any[]) {
        const record = records[0]
        this.$router.push({
            path: "/manage/product-detail",
            query: {
                software_id: String(record.software_id),
                product_id: String(record.product_id),
                is_edit: "1"
            }
        })
    }
    async onRecovery(records: any[]) {
        try {
            const record = records[0]
            await manageService.recoverProduct({
                product_id: record.product_id
            })
            this.$message.success("恢复成功！")
            this.getList()
        } catch (error) {
            this.$message.error(`${error}`)
        }
    }
    onOnShelf(records: any[]) {
        this.onShelf.record = records[0]
        this.onShelf.form.on_shelf_time = ""
        this.onShelf.visible = true
    }
    async confirmOnShelf() {
        try {
            await this.refOnShelfForm.validate()
            await manageService.onShelfProduct({
                product_id: this.onShelf.record.product_id,
                ...this.onShelf.form,
                on_shelf_time: dayjs(this.onShelf.form.on_shelf_time).valueOf()
            })
            this.$message.success("上架成功！")
            this.onShelf.visible = false
            this.getList()
        } catch (error) {
            if (error) {
                this.$message.error(`${error}`)
            }
        }
    }
    onOffShelf(records: any[]) {
        this.offShelf.record = records[0]
        this.offShelf.form.off_shelf_time = ""
        this.offShelf.form.off_shelf_reason = ""
        this.offShelf.visible = true
    }
    async confirmOffShelf() {
        try {
            await this.refOffShelfForm.validate()
            await manageService.offShelfProduct({
                product_id: this.offShelf.record.product_id,
                ...this.offShelf.form,
                off_shelf_time: dayjs(this.offShelf.form.off_shelf_time).valueOf()
            })
            this.$message.success("下架成功！")
            this.offShelf.visible = false
            this.getList()
        } catch (error) {
            if (error) {
                this.$message.error(`${error}`)
            }
        }
    }
    handleExport() {
        const offset = (this.pagination.current - 1) * this.pagination.pageSize
        const limit = this.pagination.pageSize

        // 初始化导出参数，所有筛选字段都以数组形式传递
        const payload: any = {
            corporate: [],
            dept: [],
            product_id: [],
            product_name: "",
            product_sub_type: [],
            product_type: [],
            software_id: [],
            status: [],
            offset,
            limit
        }

        // 处理筛选条件，将值转换为数组形式
        this.filters.forEach(item => {
            if (item.dataIndex === "software_name") {
                // software_name 对应 software_id
                payload.software_id = Array.isArray(item.keyword) ? item.keyword : [item.keyword]
            } else if (item.dataIndex === "product_name") {
                // 产品名称保持字符串形式
                payload.product_name = item.keyword || ""
            } else if (item.dataIndex === "status") {
                // status 需要转换为整型数组
                const statusValues = Array.isArray(item.keyword) ? item.keyword : [item.keyword]
                payload.status = statusValues.map((val: any) => Number(val))
            } else {
                // 其他字段转换为数组形式
                payload[item.dataIndex] = Array.isArray(item.keyword)
                    ? item.keyword
                    : [item.keyword]
            }
        })

        manageService
            .exportProductsList(payload)
            .catch(err => {
                this.$message.error(`${err}`)
            })
            .finally(() => {
                this.exportLoading = false
            })
    }
    async onSearch(
        keyword: string,
        pagination: any,
        sorts: any[],
        filters: any[]
    ): Promise<{ total: number; list: any[] }> {
        Object.assign(this.searchParams, { keyword, pagination, sorts, filters })
        // 如果传入了pagination参数，则使用传入的参数更新当前分页状态
        if (pagination) {
            this.pagination.current = pagination.current || this.pagination.current
            this.pagination.pageSize = pagination.pageSize || this.pagination.pageSize
        }
        // 更新sorts和filters
        this.sorts = sorts || []
        this.filters = filters || []
        return this.getList()
    }
    async getList(): Promise<{ total: number; list: any[] }> {
        const offset = (this.pagination.current - 1) * this.pagination.pageSize
        const limit = this.pagination.pageSize
        const query: any = {}
        this.filters.forEach(item => {
            if (item.dataIndex === "software_name") {
                query.software_id = item.keyword
            } else {
                query[item.dataIndex] = item.keyword
            }
        })

        const payload = {
            offset,
            limit,
            ...query
        }
        this.loading = true
        try {
            const res: any = await manageService.getProductsList(payload)
            const { list, total } = res || {}
            this.tableData = list || []
            this.pagination.total = total
            return {
                list,
                total
            }
        } catch (error) {
            if (error) {
                this.$message.error(`获取数据失败！ ${error}`)
            }
        } finally {
            this.loading = false
        }
    }

    filterChange(filters: any[]) {
        this.filters = filters
        this.pagination.current = 1
        this.getList()
    }

    sortsChange(sorts: any[]) {
        this.sorts = sorts
        this.pagination.current = 1
        this.getList()
    }

    // 需手动设置advanceTable的ref为table
    manualSearch() {
        this.pagination.current = 1
        this.selectedRowKeys = []
        this.selectedRows = []
        this.getList()
    }
}
